import { Menu, Tooltip } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

const navItems = [
  {
    label: "단어장",
    key: "wordbook",
    path: "/",
  },
  {
    label: "단어 만들기",
    key: "wordmaker",
    path: "/wordmaker",
  },
  {
    label: (
      <Tooltip title="아직 준비중인 기능입니다." color="#3D90EF">
        <span>짝 맞추기</span>
      </Tooltip>
    ),
    key: "matching",
    path: "/matching",
  },
  {
    label: (
      <Tooltip title="아직 준비중인 기능입니다." color="#3D90EF">
        <span>AI 보고서</span>
      </Tooltip>
    ),
    key: "ai-reports",
    path: "/ai-reports",
  },
];

const Header = () => {
  const [current, setCurrent] = useState("wordbook");
  const navigate = useNavigate();

  const navClick = (e) => {
    setCurrent(e.key);
    const selectedItem = navItems.find((item) => item.key === e.key);
    if (selectedItem && !selectedItem.disabled) {
      navigate(selectedItem.path);
    }
  };

  return (
    <header>
      <div className="header-inner">
        <a href="/">
          <img className="logo cursor-pointer" src={logo} alt="logo" />
        </a>
        <Menu
          className="header-menu"
          onClick={navClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={navItems}
        />
      </div>
    </header>
  );
};

export default Header;
